import { makeOperator } from './Operator';
const zipcodePattern = /^\d{5}(-\d{4})?$/;

/**
 * A special operator for distance queries against zipcodes.
 */
export default makeOperator({
  name: 'Near',
  values: [{
    name: 'value',
    defaultValue: '',
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'unknown' is not assignable to pa... Remove this comment to see the full error message
    isValid: value => zipcodePattern.test(value)
  }]
});